var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNavDashboard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.c{fill:none;}.a{stroke:#ff5a5a;opacity:0;}.b{stroke:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(18201 24034)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M689,49.479a2.525,2.525,0,0,0-2.47,2.021h-3.579l-3.467-13.624A.5.5,0,0,0,679,37.5h0a.5.5,0,0,0-.484.375L673,59.33l-3.513-13.456A.5.5,0,0,0,669,45.5h0a.5.5,0,0,0-.483.376L667.08,51.5H662a.5.5,0,0,0,0,1h5.469a.5.5,0,0,0,.484-.376L669.006,48l3.511,13.45a.5.5,0,0,0,.483.373h0a.5.5,0,0,0,.483-.375L679,40.017l3.081,12.107a.5.5,0,0,0,.484.376h3.968A2.521,2.521,0,1,0,689,49.479Zm0,4A1.479,1.479,0,1,1,690.479,52,1.481,1.481,0,0,1,689,53.479Z",
    transform: "translate(-18862 -24068)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(-18201 -24034)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 32,
    height: 32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavDashboard);
export default __webpack_public_path__ + "static/media/nav-dashboard.e5cb85f8670565f7d3be782f6937be3b.svg";
export { ForwardRef as ReactComponent };